(() => {
  const init = (root) => {
    if (!root || root.dataset.cvAboutReady === 'true') return;
    root.dataset.cvAboutReady = 'true';
    document.body.classList.add('cv-about-page');
    document.documentElement.classList.add('cv-about-page');

    const nav = root.querySelector('[data-cv-about-nav]');
    if (!nav) return;
    const links = Array.from(nav.querySelectorAll('a[href^="#"]'));
    const sections = links
      .map((link) => document.querySelector(link.getAttribute('href')))
      .filter(Boolean);

    const activate = (id) => {
      let activeLink;
      links.forEach((link) => {
        if (link.getAttribute('href') === `#${id}`) {
          link.setAttribute('aria-current', 'location');
          activeLink = link;
        }
        else link.removeAttribute('aria-current');
      });

      if (activeLink && nav.scrollWidth > nav.clientWidth) {
        nav.scrollTo({
          left: activeLink.offsetLeft - (nav.clientWidth - activeLink.offsetWidth) / 2,
          behavior: 'smooth',
        });
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        const current = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (current) activate(current.target.id);
      },
      { rootMargin: '-18% 0px -64% 0px', threshold: [0, 0.2, 0.6] },
    );

    sections.forEach((section) => observer.observe(section));
  };

  const initAll = () => document.querySelectorAll('[data-cv-about]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
